
import {map} from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';

import {Observable} from "rxjs";
import "rxjs/Rx";

import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class NavigationService extends Baseservice {

    constructor(http: HttpClient, authentication: AuthenticationService) {
        super("navigation",http, authentication);
    }

    get() {
        return this.getNavigation(this.url + "/navigation");
    }

    getById(id: any) {
        return this.getNavigation(this.url + "/find/" + id);
    }

    getNavigation(url: string) {
        return this.getRequest(url).pipe(map(response => response)); 
    }

    //Create new navigation item
    postNavigation(object : any, typeid: any, invoiceid: any) {

        let body = object;
        return this.http.post(this.url, body);
    }

    //Update a navigation item
    putNavigation(object) {

        let body = object;
        return this.update(body);
    }

    //Delete a navigation item
    deleteNavigation(id: number) {

        return this.delete(id).pipe(map(response => response));
    }
}

